(function () {
  'use strict';

  // Translatable strings (nb.js.* locale keys), rendered once by sections/nb-shell-header.liquid
  // into <script id="nb-i18n-strings">. Falls back to the English passed in.
  function nbT(k, f) {
    var s = window.__nbI18n;
    if (!s) {
      var el = document.getElementById('nb-i18n-strings');
      try { s = el ? JSON.parse(el.textContent) : {}; } catch (e) { s = {}; }
      window.__nbI18n = s;
    }
    return s[k] || f;
  }

  var CFG = window.NB_REGION || {};
  var STORES = CFG.stores || {};
  var CURRENT = CFG.current || 'SG';
  var COOKIE_NAME = 'nb_region';
  var COOKIE_DAYS = CFG.cookieDays || 90;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  function hasPaidTrafficSignal() {
    var qs = window.location.search;
    if (!qs) return false;
    var params = new URLSearchParams(qs);
    var paid = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid', 'msclkid', 'ttclid'];
    for (var i = 0; i < paid.length; i++) {
      if (params.has(paid[i])) return true;
    }
    return false;
  }

  function destinationUrl(regionKey) {
    var store = STORES[regionKey];
    if (!store) return null;
    if (regionKey === CURRENT) return null;
    var path = window.location.pathname + window.location.search + window.location.hash;
    return 'https://' + store.domain + path;
  }

  function chooseRegion(regionKey) {
    writeCookie(COOKIE_NAME, regionKey, COOKIE_DAYS);
    var url = destinationUrl(regionKey);
    if (url) {
      window.location.href = url;
    } else {
      hidePopup();
    }
  }

  function detectIpRegion() {
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        resolve(null);
      }, 1500);

      try {
        fetch('https://ipapi.co/country/', { method: 'GET' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (code) {
            if (done) return;
            done = true;
            clearTimeout(timer);
            resolve(code ? code.trim().toUpperCase() : null);
          })
          .catch(function () {
            if (done) return;
            done = true;
            clearTimeout(timer);
            resolve(null);
          });
      } catch (e) {
        clearTimeout(timer);
        resolve(null);
      }
    });
  }

  var popup = null;
  function showPopup(detectedRegion) {
    popup = popup || document.getElementById('nb-region-popup');
    if (!popup) return;

    if (detectedRegion && STORES[detectedRegion] && detectedRegion !== CURRENT) {
      var s = STORES[detectedRegion];
      var eyebrow = popup.querySelector('[data-nb-region-eyebrow]');
      var title = popup.querySelector('[data-nb-region-title]');
      var sub = popup.querySelector('[data-nb-region-sub]');
      if (eyebrow) eyebrow.textContent = nbT('region_eyebrow', 'Looks like you’re in {region}').replace('{region}', s.label);
      if (title) title.textContent = nbT('region_title', 'Switch to our {region} store?').replace('{region}', s.label);
      if (sub) sub.textContent = nbT('region_sub', 'You’ll get {currency} pricing and fast local delivery from our {region} warehouse.').replace('{currency}', s.currency).replace('{region}', s.label);
    }

    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }

  function hidePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (popup) popup.hidden = true; }, 220);
    var existing = readCookie(COOKIE_NAME);
    if (!existing) writeCookie(COOKIE_NAME, CURRENT, COOKIE_DAYS);
  }

  function bindPopup() {
    popup = document.getElementById('nb-region-popup');
    if (!popup) return;
    popup.addEventListener('click', function (e) {
      var dismiss = e.target.closest('[data-nb-region-dismiss]');
      var choose = e.target.closest('[data-nb-region-choose]');
      if (dismiss) { e.preventDefault(); hidePopup(); return; }
      if (choose) {
        e.preventDefault();
        chooseRegion(choose.getAttribute('data-nb-region-choose'));
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) hidePopup();
    });
  }

  function injectSelector() {
    var tpl = document.getElementById('nb-region-selector-template');
    if (!tpl) return;

    var slots = document.querySelectorAll('.m-header__right');
    if (!slots.length) return;

    slots.forEach(function (slot) {
      if (slot.querySelector('[data-nb-region-selector]')) return;
      var node = tpl.content.firstElementChild.cloneNode(true);

      var s = STORES[CURRENT];
      var flagEl = node.querySelector('[data-nb-region-current-flag]');
      var codeEl = node.querySelector('[data-nb-region-current-code]');
      if (s && flagEl) flagEl.textContent = s.flag;
      if (s && codeEl) codeEl.textContent = s.currency;

      var activeOpt = node.querySelector('[data-nb-region-choose="' + CURRENT + '"]');
      if (activeOpt) activeOpt.setAttribute('aria-current', 'true');

      slot.insertBefore(node, slot.firstChild);
      bindSelector(node);
    });
  }

  function bindSelector(root) {
    var trigger = root.querySelector('[data-nb-region-trigger]');
    var menu = root.querySelector('[data-nb-region-menu]');
    if (!trigger || !menu) return;

    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
    }
    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      menu.hidden ? open() : close();
    });

    menu.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nb-region-choose]');
      if (!btn) return;
      e.preventDefault();
      chooseRegion(btn.getAttribute('data-nb-region-choose'));
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function init() {
    bindPopup();
    injectSelector();

    if (hasPaidTrafficSignal()) return;
    if (readCookie(COOKIE_NAME)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    detectIpRegion().then(function (region) {
      if (region && region !== CURRENT && STORES[region]) {
        showPopup(region);
      } else {
        writeCookie(COOKIE_NAME, CURRENT, COOKIE_DAYS);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
